/* eslint-disable */
export default {
  hide: '隱藏',
  end: '結束',
  keypad: '撥號盤',
} as const;

// @key: @#@"hide"@#@ @source: @#@"Hide"@#@
// @key: @#@"end"@#@ @source: @#@"End"@#@
// @key: @#@"keypad"@#@ @source: @#@"Keypad"@#@
